import moment from 'moment';
import chroma from 'chroma-js';
import { groupBy } from 'lodash-es';
export var chunkNotificationList = function chunkNotificationList(notificationList) {
  return groupBy(notificationList, function (notification) {
    return moment(notification.time).format('YYYY-MM-DD');
  });
};
export var generateNotificationItemColor = function generateNotificationItemColor(props) {
  return props.useTabs ? chroma(props.theme.colors.primary).alpha(0.05) : chroma(props.theme.colors.grey).alpha(0.3);
};